// to open tabs in Caregiver
export const TabActionCaregiver = (data, id, sideNavKey, childActiveId) => {
    return {
        type: 'Open_Caregiver_Tab',
        payload: {
            data: data,
            id: id ? id : undefined,
            sideNavKey: sideNavKey,
            childActiveId: childActiveId
        },
    }
}
export const OpenNewCaregiverTabAction = (data) => {
    return {
        type: 'Open_New_Caregiver_Tab',
        payload: {
            data: data,
        },
    }
}
export const CaregiverRecordAction = (Data) => {
    return {
        type: 'CaregiverRecordAction',
        payload: Data
    }
}
